import { WallConfig, WallPropConfig } from "@/state/RoomConfig/WallConfig";
import React from "react";
import { FurnitureInstanceRenderer } from "../FurnitureInstanceRenderer";
import { useWallPropData } from "./useWallPropData";
import { useWindowModelInstance } from "./useWindowModelInstance";

type WindowPropViewProps = {
    prop: WallPropConfig;
    wall: WallConfig;
};

// todo: a lot of hardcode - need to fix
export const WindowPropView: React.FC<WindowPropViewProps> = ({ prop, wall }) => {
    const { position, floorOffset, isSelected } = useWallPropData(prop);

    const instance = useWindowModelInstance(prop, wall);

    if (!instance) {
        return (
            <mesh
                position={[position, floorOffset + prop.height / 2, 0]}
                scale={[prop.width, prop.height, 1]}
            >
                <boxGeometry />
                <meshBasicMaterial color="yellow" />
            </mesh>
        );
    }

    return (
        <group
            position={[position - instance.instance.box.sizeZ / 2, floorOffset, 0]}
            rotation={[0, Math.PI / 2, 0]}
        >
            <FurnitureInstanceRenderer furniture={instance} isSelected={isSelected} />
        </group>
    );
};
